/**
 * "<n> <noun>" for list and picker counts, singular at exactly one
 * (#1865, Q-631 a): '1 contact', '0 contacts', '2 contacts'.
 *
 * `localize` formats the number with `toLocaleString()` (the list status bar
 * does); without it the number is printed as-is (the picker rows do).
 */
export function countLabel(
  n: number,
  singular: string,
  plural: string,
  options?: { localize?: boolean },
): string {
  const shown = options?.localize ? n.toLocaleString() : String(n);
  return `${shown} ${n === 1 ? singular : plural}`;
}
